import Breadcrumb from '@/components/base/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function About() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于香蕉漫画网',
    description: '香蕉漫画网是一个免费在线漫画阅读平台，致力于为漫画爱好者提供海量免费漫画资源。',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '香蕉漫画网的漫画真的全部免费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的！香蕉漫画网所有漫画均免费阅读，无需付费、无需会员，零成本畅享全本漫画。我们致力于为广大漫画爱好者提供最优质的免费漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '香蕉漫画网有哪些类型的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '香蕉漫画网拥有丰富的漫画类型，包括热血、恋爱、搞笑、奇幻、科幻、悬疑、武侠、校园、都市、恐怖、日漫、国漫等，满足不同读者的阅读偏好。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们保持每日免费更新，确保读者能够第一时间看到最新的漫画章节。热门漫画通常每周更新，部分漫画实现日更。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在手机上阅读漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '香蕉漫画网采用响应式设计，完美适配手机、平板和电脑。您只需在手机浏览器中打开网站即可享受流畅的漫画免费阅读体验，无需下载任何APP。',
        },
      },
      {
        '@type': 'Question',
        name: '漫画资源来自哪里？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '本站漫画资源均来源于网络收集，版权归原作者及出版社所有。若涉及版权问题，请通过联系方式与我们沟通，我们将及时处理。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="bg-background-100/70 border-b border-background-200/70">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <div className="pb-6">
              <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                关于香蕉漫画网
              </h1>
            </div>
          </div>
        </div>

        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
          <section className="mb-16">
            <div className="flex flex-col lg:flex-row gap-10 items-center">
              <div className="lg:w-1/2">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20and%20warm%20reading%20atmosphere%20with%20manga%20books%20and%20a%20cup%20of%20tea%20on%20a%20wooden%20table%2C%20soft%20natural%20light%20from%20window%2C%20Japanese%20aesthetic%20interior%2C%20warm%20amber%20and%20cream%20tones%2C%20peaceful%20and%20inviting%20mood%2C%20high%20quality%20photography%20style&width=800&height=600&seq=about-brand-manga&orientation=landscape"
                  alt="香蕉漫画网 - 温馨的漫画阅读氛围"
                  className="w-full rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-4">
                  品牌介绍
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  香蕉漫画网成立于2024年，是一个专注于免费漫画阅读的在线平台。我们深知漫画爱好者的需求——<strong>漫画免费阅读</strong>、<strong>免费看漫画</strong>、<strong>免费更新</strong>是每一位读者的核心诉求。因此，香蕉漫画网从创立之初就确立了"零成本畅享全本漫画"的核心理念。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  作为国内领先的<strong>免费漫画大全</strong>平台，香蕉漫画网汇聚了海量<strong>免费在线漫画</strong>资源，涵盖热血、恋爱、搞笑、奇幻、科幻、悬疑、武侠、校园、都市、恐怖等多种类型。无论你喜欢日漫还是国漫，都能在这里找到心仪的作品。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  我们坚持<strong>免费漫画</strong>的理念，致力于为每一位漫画爱好者提供<strong>无限阅读</strong>的畅快体验。让每一个热爱漫画的人，都能<strong>免费看漫画</strong>、<strong>免费全集</strong>、<strong>漫画免费看</strong>，尽情享受<strong>免费资源</strong>带来的阅读乐趣。
                </p>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-8 text-center">
              我们的优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: 'ri-money-cny-circle-line',
                  title: '完全免费',
                  desc: '所有漫画免费阅读，无需任何付费，零成本畅享全本漫画。',
                },
                {
                  icon: 'ri-refresh-line',
                  title: '每日更新',
                  desc: '热门漫画保持高频免费更新，第一时间为你推送最新章节。',
                },
                {
                  icon: 'ri-stack-line',
                  title: '海量资源',
                  desc: '免费漫画大全涵盖12大分类，数千部漫画任你挑选。',
                },
                {
                  icon: 'ri-smartphone-line',
                  title: '多端适配',
                  desc: '完美支持手机、平板和电脑，随时随地免费看漫画。',
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-200"
                >
                  <span className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading text-foreground-900 font-semibold mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-8 text-center">
              用户口碑
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  name: '小明同学',
                  comment: '香蕉漫画网真的太棒了！免费漫画大全里什么类型的都有，每天都有免费更新，再也不用到处找资源了。强烈推荐！',
                  rating: 5,
                },
                {
                  name: '漫画爱好者阿杰',
                  comment: '作为十几年的老漫画迷，香蕉漫画网是我用过最好的免费在线漫画平台。资源丰富，更新快，而且真的是免费全集！',
                  rating: 5,
                },
                {
                  name: '小樱',
                  comment: '太爱这个免费看漫画的网站了！界面清爽，分类清晰，漫画免费看真的很方便。每天都要上来刷一刷最新更新。',
                  rating: 5,
                },
              ].map((review) => (
                <div
                  key={review.name}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: review.rating }).map((_, i) => (
                      <span key={i} className="w-4 h-4 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-sm"></i>
                      </span>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{review.comment}&rdquo;
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">— {review.name}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mb-8 text-center">
              联系我们
            </h2>
            <div className="max-w-2xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                {
                  icon: 'ri-mail-line',
                  title: '电子邮箱',
                  content: 'contact@bananamanga.com',
                },
                {
                  icon: 'ri-customer-service-line',
                  title: '在线客服',
                  content: '工作日 9:00 - 18:00',
                },
                {
                  icon: 'ri-wechat-line',
                  title: '微信公众号',
                  content: '香蕉漫画网',
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="p-6 rounded-xl bg-background-100 border border-background-200/70 text-center"
                >
                  <span className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-1">{item.title}</h3>
                  <p className="text-xs text-foreground-500">{item.content}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}